import React from "react";
import { motion } from "framer-motion";
import { FaTag, FaVideo, FaCode, FaHeadset, FaMapMarkerAlt, FaComments } from "react-icons/fa";
import "./About.css";

const reasons = [
  { icon: FaTag, title: "Fixed-price quotes", text: "You know the cost before we start. No surprise invoices." },
  { icon: FaVideo, title: "Weekly demos", text: "See working software every week and steer it as it grows." },
  { icon: FaCode, title: "You own the code", text: "The source code and your data belong to you, always." },
  { icon: FaHeadset, title: "Support after launch", text: "Maintenance plans and fast fixes, so you're never left alone." },
  { icon: FaMapMarkerAlt, title: "Local, and global-ready", text: "Based in Sri Lanka, building for local and international customers." },
  { icon: FaComments, title: "Plain-language talk", text: "We explain options simply and recommend what fits your budget." },
];
// this is test
const About = () => (
  <section id="about" className="lk-section lk-section-alt">
    <div className="lk-container">
      <motion.div
        className="lk-section-head"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <div>
          <div className="lk-eyebrow">Why Lankovate</div>
          <h2 className="lk-h2">A young team that cares about your result.</h2>
        </div>
        <p className="lk-lead">
          Lankovate Technologies is a Sri Lankan software startup. We work
          closely with each client and stand behind what we build.
        </p>
      </motion.div>

      <div className="lk-why">
        {reasons.map(({ icon: Icon, title, text }, i) => (
          <motion.div
            key={title}
            className="lk-card lk-why-item"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
          >
            <span className="lk-icon-tile"><Icon aria-hidden="true" /></span>
            <h3>{title}</h3>
            <p>{text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default About;
